import React from "react";
import styles from "./savingModal.module.css";
import { ImSpinner4 } from "react-icons/im";

export default function SavingModal() {
  return (
    <div className={styles.savingModal}>
      <div className={styles.content}>
        <h3>
          <ImSpinner4 /> Saving...
        </h3>
      </div>
    </div>
  );
}
